// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".star-button {\n  background: transparent;\n  font-size: fl;\n  float: left;\n}", "",{"version":3,"sources":["webpack://./src/app/components/rating/rating.scss"],"names":[],"mappings":"AACA;EACE,uBAAA;EACA,aAAA;EACA,WAAA;AAAF","sourcesContent":["\n.star-button {\n  background: transparent;\n  font-size: fl;\n  float: left;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
